import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GoogleMapsLoaderService {
    private loadPromise: Promise<void> | null = null;

    constructor() {}

    loadGoogleMaps(apiKey: string): Promise<void> {
        if (this.loadPromise) {
            return this.loadPromise;
        }

        this.loadPromise = new Promise<void>((resolve, reject) => {
            const callbackName = '__googleMapsReady';
            const script = document.createElement('script');

            const fail = (error: any) => {
                script.remove();
                delete (window as any)[callbackName];
                this.loadPromise = null;
                reject(error);
            };

            (window as any)[callbackName] = async () => {
                ['marker', 'places', 'geometry'].forEach((library) => {
                    google.maps
                        .importLibrary(library)
                        .catch((error: any) =>
                            console.warn(
                                `No se pudo precargar la librería "${library}" de Google Maps:`,
                                error
                            )
                        );
                });

                try {
                    await google.maps.importLibrary('maps');
                } catch (error) {
                    fail(error);
                }
                resolve();
            };

            script.src =
                'https://maps.googleapis.com/maps/api/js?key=' +
                apiKey +
                `&libraries=places,marker,geometry&language=ES&region=GT&loading=async&callback=${callbackName}`;
            script.async = true;
            script.defer = true;
            script.onerror = (error: any) => fail(error);

            document.head.appendChild(script);
        });

        return this.loadPromise;
    }
}
